var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFbColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.0785C25.9991 5.85541 20.1796 0 13 0C5.82035 0 0 5.85628 0 13.0802C0 19.5829 4.71592 24.9769 10.8934 25.9895L10.968 26V16.8606H7.66684V13.0785H10.968V10.1983C10.9515 10.0527 10.9429 9.88345 10.9429 9.71249C10.9429 7.16291 12.9974 5.09568 15.5313 5.09568C15.6536 5.09568 15.7749 5.10091 15.8954 5.10963L15.8798 5.10876C16.9192 5.12359 17.9248 5.21605 18.9062 5.3809L18.79 5.36433V8.58293H17.1498C17.0753 8.57246 16.9895 8.56636 16.9028 8.56636C15.8651 8.56636 15.0233 9.41244 15.0233 10.4574C15.0233 10.5167 15.0259 10.5751 15.0311 10.6336L15.0303 10.6257V13.0785H18.6357L18.0592 16.8606H15.0303V26C21.2832 24.976 25.9991 19.5811 26 13.0785Z",
    fill: "#4781FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFbColor);
export default __webpack_public_path__ + "static/media/icon_fb_color.d76df22ab88e8cd44d51f73a6006d76a.svg";
export { ForwardRef as ReactComponent };